import { Link } from 'react-router-dom';
import BrandMark from './BrandMark';
import TextNowLink from './TextNowLink';
import { CONTACT } from '../data/siteData';

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-grid">
        <div>
          <BrandMark compact />
          <p>Professional towing and roadside assistance with a little more care, personality and community spirit.</p>
        </div>
        <div>
          <h3>Get Help</h3>
          <a href={CONTACT.phoneHref} data-roka-cta="call_dispatch" data-roka-label="Call dispatch">{CONTACT.phoneDisplay}</a>
          <TextNowLink>Text Now</TextNowLink>
          <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>
        </div>
        <div>
          <h3>Explore</h3>
          <Link to="/services">Services</Link>
          <Link to="/experiences">Experiences</Link>
          <Link to="/games">Games While You Wait</Link>
          <Link to="/halloween-holiday-trucks">Halloween &amp; Holiday Trucks</Link>
          <Link to="/jonnys-towing-x-nespresso">Nespresso Experience</Link>
          <Link to="/in-the-community">Community</Link>
          <Link to="/community/halloween">🎃 Halloween School Donations</Link>
          <Link to="/portal/login">Client Courses</Link>
          <Link to="/portal/claim">Claim Vehicle Record</Link>
        </div>
        <div>
          <h3>Legal</h3>
          <Link to="/privacy-policy">Privacy Policy</Link>
          <Link to="/terms-conditions">Terms &amp; Conditions</Link>
          <Link to="/admin">Site Administration</Link>
        </div>
      </div>
      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} Jonny’s Towing &amp; Recovery Ltd.</span>
        <span>Richmond, British Columbia</span>
      </div>
    </footer>
  );
}
